<template>
  <v-alert class="mt-2" dense :type="type">
    <template v-slot:prepend>
      <v-icon class="mr-4">{{ icon }}</v-icon>
    </template>
    <slot></slot>
  </v-alert>
</template>

<script>
export default {
  props: {
    icon: {
      default: "fas fa-exclamation-triangle",
      type: String,
    },
    type: {
      default: "warning",
      type: String,
    },
  },
};
</script>
